import React from 'react';
import cn from 'classnames';

import { openGladlyChat } from '../../../../utils/gladly';

import styles from './styles.module.scss';

const LoginForm = ({ title, description, children, submitHandle, type }) => {
  return (
    <form
      className={cn(styles.form, {
        [styles.codeVerification]: type === 'codeVerification',
        [styles.deviceActivation]: type === 'deviceActivation',
        [styles.requestDeviceSn]: type === 'requestDeviceSn',
      })}
      onSubmit={submitHandle}
    >
      <h1 className={cn('h2', styles.formTitle)}>{title}</h1>
      {description && (
        <p className={cn('text', styles.formDesc)}>{description}</p>
      )}
      <div className={styles.formContent}>{children}</div>
      <div className={styles.formFooter}>
        <button
          className={styles.formChatButton}
          type="button"
          onClick={openGladlyChat}
        >
          <span>Need help?</span>
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
